const PIXEL_RAW = (process.env.REACT_APP_META_PIXEL_ID || "").trim();
// User mungkin menempel seluruh snippet — ekstrak ID angka 10-20 digit
const PIXEL_ID = /^\d{10,20}$/.test(PIXEL_RAW)
  ? PIXEL_RAW
  : (PIXEL_RAW.match(/fbq\(\s*['"]init['"]\s*,\s*['"](\d{10,20})['"]/)?.[1] || PIXEL_RAW.match(/\b(\d{13,17})\b/)?.[1] || "");
// GA4 dipasang langsung via gtag.js di public/index.html (G-WYYCX8FQVK) — tidak diinjeksi di sini.

const fbq = (...args) => { try { window.fbq && window.fbq(...args); } catch { /* noop */ } };
const gtag = (...args) => { try { window.gtag && window.gtag(...args); } catch { /* noop */ } };
const ph = (event, props) => { try { window.posthog?.capture?.(event, props); } catch { /* noop */ } };

export const initTracking = () => {
  if (window.__naluraTrackingInit) return;
  window.__naluraTrackingInit = true;

  if (PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
  }
};

let _lastPV = { path: "", at: 0 };

export const trackPageView = (path) => {
  const now = Date.now();
  if (_lastPV.path === path && now - _lastPV.at < 1500) return;
  _lastPV = { path, at: now };
  fbq("track", "PageView");
  // tunda sejenak agar document.title halaman baru sudah ter-set
  setTimeout(() => {
    gtag("event", "page_view", {
      page_path: path,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, 150);
};

export const trackEvent = (name, params = {}) => {
  gtag("event", name, params);
  ph(name, params);
};

export const trackProductClick = (productName, section) => {
  fbq("track", "InitiateCheckout", { content_name: productName, content_category: "affiliate", currency: "IDR" });
  trackEvent("klik_produk", { produk: productName, lokasi: section });
};

export const trackLead = (sumber) => {
  fbq("track", "Lead");
  trackEvent("generate_lead", { sumber });
};
